export class DataAndTypeModel {
	public value: string;
	public valueType: string;

	public constructor(params: Partial<DataAndTypeModel>) {
		this.value = params.value;
		this.valueType = params.valueType;
	}
}
